import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translation } from "react-i18next";

import { connect } from 'react-redux';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import FixedNotification from 'components/common/FixedNotification';

import './YourHeylinkSite.css';


function YourHeylinkSite(props) {
  const { me } = props;

  const [copyUrl, setCopyUrl] = useState(false);

  return (
    <Translation>
      {(t) => (
        <div className="your-heylink-site__component">
          <div className="label">{t("Your HeyLink.me Site")}</div>
          <div className="value-wrapper">
            <div className="link">
              <a href={me.url} target="_blank" rel="noopener noreferrer">
                {me.url}
              </a>
            </div>
    
            <CopyToClipboard
              text={me.url}
              onCopy={() => setCopyUrl(true)}
            >
              <div className="copy-button">
                <div className="icon" />
                <div className="text">{t("Copy")}</div>
              </div>
            </CopyToClipboard>
          </div>
    
          {copyUrl &&
            <FixedNotification
              onFadeComplete={() => setCopyUrl(false)}
            >
              {t("Link has been copied: paste it anywhere!")}
            </FixedNotification>
          }
        </div>
      )}
    </Translation>
  );
}

YourHeylinkSite.propTypes = {
  me: PropTypes.object,
};

YourHeylinkSite.propTypes = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {},
)(YourHeylinkSite);
